import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import API from "../services/api";
import { buildWhatsAppUrl, openExternalLink } from "../utils/appInteractions";

const CACHE_KEY = "posm_wa_number";
const CACHE_TTL = 10 * 60 * 1000; // 10 min

function getCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { value, at } = JSON.parse(raw);
    if (Date.now() - at > CACHE_TTL) return null;
    return value;
  } catch {
    return null;
  }
}

function setCache(value) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ value, at: Date.now() }));
  } catch {}
}

export default function WhatsAppFloatBtn() {
  const { pathname } = useLocation();
  const [phone, setPhone] = useState(() => getCache());

  // don't show on admin / agent pages
  const hidden = /^\/(admin|agent)/.test(pathname);

  useEffect(() => {
    if (hidden) return;
    const cached = getCache();
    if (cached !== null) { setPhone(cached); return; }
    API.get("/settings/public")
      .then((res) => {
        const raw = String(res.data?.whatsapp_number || "").replace(/\D/g, "");
        const cleaned = raw.length === 10 ? `91${raw}` : raw.length >= 11 ? raw : "";
        setCache(cleaned);
        setPhone(cleaned);
      })
      .catch(() => {});
  }, [hidden]);

  if (hidden || !phone) return null;

  const handleClick = () => {
    const url = buildWhatsAppUrl(phone, "Hello, I need support from Play Online Satta Matka");
    if (url) openExternalLink(url);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={fab}
      aria-label="Chat on WhatsApp"
      title="WhatsApp Support"
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M16 2a14 14 0 0 0-12.1 21L2 30l7.2-1.9A14 14 0 1 0 16 2zm0 25.5a11.5 11.5 0 0 1-5.9-1.6l-.4-.3-4.9 1.3 1.3-4.8-.3-.4A11.5 11.5 0 1 1 16 27.5zm6.3-8.7c-.3-.2-2-.1-2.3-.1s-.4.2-.7.5l-1 1.3c-.2.2-.4.3-.7.1a9.5 9.5 0 0 1-2.8-1.8 10.5 10.5 0 0 1-1.9-2.4c-.2-.3 0-.5.2-.7l.6-.7.3-.6v-.6l-1-2.5c-.3-.6-.6-.5-.8-.5h-.7c-.3 0-.7.1-1.1.5-.3.4-1.3 1.3-1.3 3.1s1.3 3.6 1.5 3.8c.2.3 2.7 4.2 6.6 5.7.9.4 1.6.6 2.2.8.9.3 1.8.2 2.4.1.7-.1 2.1-.9 2.4-1.7.3-.8.3-1.4.2-1.6-.1-.1-.3-.2-.6-.4z"
          fill="#fff"
        />
      </svg>
    </button>
  );
}

const fab = {
  position: "fixed",
  bottom: 88,
  right: 16,
  zIndex: 9999,
  width: 50,
  height: 50,
  padding: 0,
  display: "grid",
  placeItems: "center",
  background: "#25D366",
  border: 0,
  borderRadius: "50%",
  boxShadow: "0 3px 12px rgba(37,211,102,.5), 0 1px 4px rgba(0,0,0,.18)",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
};
